import { createApp } from "vue";
import hash from "../hash";
import { may, toDate, toPrix } from "./composant/b2bLangue";
import { dropdownFilter } from './composant/dropdownFilter';

import { Dropdown, Popover, Tooltip } from 'bootstrap';
import Fuse from 'fuse.js';
import Store from "../Store";
import { JeuDeDonnees, PrepareEtat } from './composant/PrepareEtatV1';

import $ from "jquery";

//
const imagPardefaut = "0000000/0000000_0000_1_*.png"

const popover = new Tooltip(document.body, {
	selector: "[data-bs-toggle='popover']",
	trigger: 'click'
})

import htmlLinelist from "./linelist.html";

const jsLinelist = ({
	topbar: true,
	url: function (echangeur) {
		echangeur.addAction('b2b.linelist.view', echangeur.hash, '', 'data');
		echangeur.addAction('b2b.codification.mapK', { classe: "linelisttri" }, '', 'linelisttri');
		echangeur.addAction('b2b.brandname.list', {}, '', 'brandname');
		echangeur.addAction('param.orderdepartment.list', {}, '', 'departements');
	},
	onLoad: async function (echangeur) {
		const modeEdit = echangeur.hash.preview;
		//
		const CTX = Store.get("CTX");
		const mayOrder = CTX.session.droits.CREORD;
		let THIS = this;

		let currentOrder = await Store.get("getCurrentOrder")();

		const product = echangeur.data.rows;
		const toc = echangeur.data.docToc;
		let isnewproductadd = true

		for (const row of product) {
			row.img = "download/product/" + ((row.img) ? row.img.replace("*", "S") : imagPardefaut.replace("*", "S"));
			row.selected = true;
			row.saisie = { qt: '' }
		}

		const selectedProducts = echangeur.data.linelist.selectedProducts || {};
		if (selectedProducts.include) {
			for (const row of product) row.selected = (selectedProducts.include.indexOf(row.reference) >= 0);
			isnewproductadd = false
		}
		if (selectedProducts.exclude) {
			for (const row of product) row.selected = (selectedProducts.exclude.indexOf(row.reference) < 0);
			isnewproductadd = true
		}
		if (true || "pour mettre à jours les produits pour la recherche") {
			for (const row of product) row.exclus = (row["flags"].exclus) ? "exclus" : "";
		}

		//
		//
		let levels = [];
		const regroupment = echangeur.data.linelist.regroupment;
		if (regroupment.level1.k) levels.push(regroupment.level1.k)
		if (regroupment.level2.k) levels.push(regroupment.level2.k)
		//
		const tri = regroupment.sort;
		let fonctionTri = ['des'];
		if (tri.k && echangeur.linelisttri[tri.k]) fonctionTri = echangeur.linelisttri[tri.k].data;
		// console.log("linelisttri", echangeur.linelisttri,"sortArray",sortArray);
		const prepareEtat = new PrepareEtat(levels, fonctionTri);
		//
		const jeuDeDonnees = new JeuDeDonnees(product);
		//
		let currentPopover = null;
		async function createPopover(target, message) {
			//
			if (currentPopover) {
				clearTimeout(currentPopover.id);
				currentPopover.popover.dispose()
			}
			//
			const popover = new Popover(target, {
				container: target,
				content: message,
				title: 'Message'
			})
			popover.show();
			const id = setTimeout(function () {
				popover.dispose();
				currentPopover = null;
			}, 2000);
			currentPopover = { popover, id };
			//
		}
		//
		//
		const filterListes = {
			department: jeuDeDonnees.addFilterList('department'),
			deliverytheme: jeuDeDonnees.addFilterList('deliverytheme'),
			collectiontype: jeuDeDonnees.addFilterList('collectiontype'),
			collectiongroup: jeuDeDonnees.addFilterList('collectiongroup'),
			macrofamily: jeuDeDonnees.addFilterList('macrofamily'),
			family: jeuDeDonnees.addFilterList('family'),
			embellishment: jeuDeDonnees.addFilterList('embellishment'),
			matprin: jeuDeDonnees.addFilterList('matprin'),
			// press -- exclusivity			
			guideline: jeuDeDonnees.addFilterList('guideline'),
			line: jeuDeDonnees.addFilterList('line'),
			haut: jeuDeDonnees.addFilterList('haut'),
			couG: jeuDeDonnees.addFilterList('couG'),
			exclus: jeuDeDonnees.addFilterList('exclus'),
			// stock: jeuDeDonnees.addFilterList('stock'), // @TODO
			//
			// Avirer
			col: jeuDeDonnees.addFilterList('col'),
			cef: jeuDeDonnees.addFilterList('k'),
			des: jeuDeDonnees.addFilterList('gamV'),
			//
		}

		// console.log('filterListes', toc.onstock)
		// if (toc.onstock) {
		// 	filterListes.stock = jeuDeDonnees.addFilterList('stock');
		// }

		const filterRef = jeuDeDonnees.addFilterList('reference');
		const fuse = new Fuse(product, {
			includeScore: false,
			minMatchCharLength: 2,
			threshold: 0.0,
			keys: [
				'reference', 'v', 'cou', 'deliverytheme', "line", "macrofamily", "family", "stock"
			]
		})

		//
		function getFilter(name) {
			const a = filterListes[name];
			if (a) {
				return a;
			} else {
				window.alert("filtreFin code inconnu : " + name);
			}
		}

		let deps = {}
		for (let dep of echangeur.departements.rows) {
			deps[dep.k] = { k: dep.k, rows: dep.productdepartments, v: dep.v }
		}
		//console.log(deps)

		//
		const orderManagerData = Store.get("getData")();



		const app = createApp({
			components: {
				'dropdown-filter': dropdownFilter,
			},
			data: function () {

				const a = [
					{ name: "department", title: "Department", dropdown: { name: 'department', key: 0, list: [], checked: [], actif: false } },
					{ name: "deliverytheme", title: "Delivery Theme", dropdown: { name: 'deliverytheme', key: 0, list: [], checked: [], actif: false } },
					{ name: "collectiongroup", title: "Collection group", dropdown: { name: 'collectiongroup', key: 0, list: [], checked: [], actif: false } },
					{ name: "collectiontype", title: "Collection type", dropdown: { name: 'collectiontype', key: 0, list: [], checked: [], actif: false } },
					{ name: "guideline", title: "Buying guideline", dropdown: { name: 'guideline', key: 0, list: [], checked: [], actif: false } },
					{ name: "line", title: "Line", dropdown: { name: 'line', key: 0, list: [], checked: [], actif: false } },
					{ name: "macrofamily", title: "Macro Family", dropdown: { name: 'macrofamily', key: 0, list: [], checked: [], actif: false } },
					{ name: "family", title: "Family ", dropdown: { name: 'family', key: 0, list: [], checked: [], actif: false } },
					{ name: "matprin", title: "Main material ", dropdown: { name: 'matprin', key: 0, list: [], checked: [], actif: false } },
					{ name: "embellishment", title: "Embellishment ", dropdown: { name: 'embellishment', key: 0, list: [], checked: [], actif: false } },
					{ name: "couG", title: "Generic color", filter: this.clickFilterCouG, dropdown: { name: 'couG', key: 0, list: [], checked: [], actif: false } },
					{ name: "haut", title: "Heel height", filter: this.clickFilterHaut, dropdown: { name: 'haut', key: 0, list: [], checked: [], actif: false } },
					{ name: "exclus", title: "Exclusivities", dropdown: { name: 'exclus', key: 0, list: [], checked: [], actif: false } },
				];

				const blocs = prepareEtat.construit(jeuDeDonnees.getRows());

				// if (toc.onstock) {
				// 	a.push({ name: "stock", title: "Code stocks", dropdown: { name: 'stock', key: 0, list: [], checked: [], actif: false } })
				// 	blocs.forEach(x => {
				// 		const datastock = Object.keys(x.data.stock ?? {})
				// 		x.data.stock = datastock.length > 0 ? datastock[0]: ""
				// 		return x;
				// 	});
				// }

				const activeDropdown = [];
				for (const g of a) {
					const filter = getFilter(g.name)
					if (filter) {
						const z = filter.valeursPossibles();
						// Elimine les test pour lesquels il n'y a qu'une valeur possible
						if (true || z.length > 1) activeDropdown.push(g);
					}
				}
				const mayEdit = (echangeur.data.linelist.parent && may("MAJCUS")) || (!echangeur.data.linelist.parent && may("MAJLNL"))

				/**
				 *  Retourne la liste des brandnames d'une cusstome linelist
				 */
				function brandname() {
					const linelist = echangeur.data.linelist
					if (linelist.parent) {
						const brandnameList = echangeur.brandname.rows;
						const linelistBrandname = linelist.brandnames;
						if (brandnameList && brandnameList.length > 0) {
							const lists = brandnameList.filter(u => linelistBrandname.includes(u._id)).map(u => u.v);
							if (lists.length > 0) return lists.join(', ');
							return lists.toString();
						}
					}
					return ''
				}
				const data = {
					modeEdit: (mayEdit) ? modeEdit : false,
					linelist: echangeur.data.linelist,
					product: product,
					blocs: blocs,
					filtreActif: {},
					onstock: toc.onstock,
					activeDropdown: activeDropdown,
					//
					orderManagerData,
					//
					mayOrder: mayOrder,
					mayEdit: mayEdit,
					//
					scTimer: 0,
					scY: 0,
					//
					searchKey: null,
					//
					isnewproductadd,
					returnAddProduct: ' ',
					brandname: brandname(),

					departements: deps
				}
				return data;

			},
			computed: {
				modeEditNbSelected: function () {
					return this.product.filter(u => u.selected).length;
				}

			},
			methods: {

				async pdf16() {
					const { dropdownBtnExport } = this.$refs;
					new Dropdown(dropdownBtnExport).hide();
					const t = await THIS.rest("b2b.linelist.pdf", {}, { linelist: this.linelist, blocs: this.blocs });
					if (t.url) window.open(t.url);
				},

				async pdf24() {
					const { dropdownBtnExport } = this.$refs;
					new Dropdown(dropdownBtnExport).hide();
					const t = await THIS.rest("b2b.linelist.pdf24", {}, { linelist: this.linelist, blocs: this.blocs });
					if (t.url) window.open(t.url);
				},

				async xlsdata() {
					const { dropdownBtnExport } = this.$refs;
					new Dropdown(dropdownBtnExport).hide();

					const tocList = await THIS.rest('b2b.toc.list', { env: echangeur.hash.env });
					const envGetDefault = await THIS.rest('b2b.env.getDefault', { env: echangeur.hash.env });

					const _idToc = tocList.rows.find(row => row.k === envGetDefault.tocK)._id
					const date = await THIS.rest("b2b.toc.listLinelistDelivery", { _id: _idToc });

					const thisLinelist = { ...this.linelist }
					thisLinelist.linelistDeliveryDate = { dateStart: toDate(date.dateStart), dateEnd: toDate(date.dateEnd) }

					const t = await THIS.rest("b2b.linelist.xlsdata", {}, { linelist: thisLinelist, blocs: this.blocs });
					if (t.url) window.open(t.url);
				},

				async xlsphoto() {
					const { dropdownBtnExport } = this.$refs;
					new Dropdown(dropdownBtnExport).hide();
					//
					const t = await THIS.rest("b2b.linelist.xlsphoto", {}, { linelist: this.linelist, blocs: this.blocs });
					if (t.url) window.open(t.url);
				},

				async xlsreview() {
					const { dropdownBtnExport } = this.$refs;
					new Dropdown(dropdownBtnExport).hide();
					//
					const t = await THIS.rest("b2b.linelist.xlsreview", {}, { linelist: this.linelist, blocs: this.blocs });
					if (t.url) window.open(t.url);
				},

				async saveQt(product) {
					if (this.mayOrder) {
						if (this.orderManagerData.currentOrder) {
							const data = await THIS.rest("b2b.saisie.addProduct", { _id: this.orderManagerData.currentOrder._id, reference: product.reference, qt: product.saisie.qt })
							Store.get("updateTotaux")(data);
							if (data.ok) {
								product.returnAddProduct = ''
							} else {
								product.returnAddProduct = data.message;
							}
						} else {
							const callback = function (a) { };
							Store.get("selectOrder")(null, callback);
						}
					}
				},

				wishlistSelected(e) {
					$('.wishlist-' + e).toggleClass("wishlistActive");
				},

				linelistImgUrl: function () {
					const vId = (this.linelist.parent) ? this.linelist.parent : this.linelist._id;
					if (this.linelist.visuel.banner) {
						return "image/linelist/" + vId + "_" + this.linelist.visuel.banner;
					}
				},
				levelGetImage: function (i) {
					const vId = (this.linelist.parent) ? this.linelist.parent : this.linelist._id;
					if (this.linelist.visuel.reg1) {
						return "image/linelist/" + vId + "_" + this.linelist.visuel.reg1;
					}
				},
				fin: function () {
					THIS.fin();
				},

				toValue(value) {
					if (!value) return;
					return value.split('|').pop();
				},

				toPrixAff(value, devise) {
					return toPrix(value, devise);
				},

				lanceSaisie: function (product) {
					hash.lance("productSaisie", {
						reference: product.reference,
						linelist: this.linelist._id,
						tocK: this.linelist.tocK
					});
				},

				modeEditToggleProduct(product) {  // modeEdit
					product.selected = !product.selected;
				},

				modeEditSelectAll() {
					for (const bloc of this.blocs) if (bloc.is == "DATA") bloc.data.selected = true;
				},

				modeEditUnselectAll() {
					for (const bloc of this.blocs) if (bloc.is == "DATA") bloc.data.selected = false;
				},

				modeEditActivate() {
					echangeur.hash.preview = "preview";
					THIS.hashChaine("linelistproduct", echangeur.hash);
				},

				modeEditCancel() {
					echangeur.hash.preview = '';
					THIS.hashChaine("linelist", echangeur.hash);
				},

				async modeEditSave(avecNouveauProduit) {
					if (avecNouveauProduit) {
						await this.modeEditSaveExclude();
					} else {
						await this.modeEditSaveInclude();
					}
				},

				async modeEditSaveInclude() {
					const listInclude = this.product.filter(u => u.selected).map(u => u.reference);
					const form = {
						_id: this.linelist._id,
						selectedProducts: { include: listInclude },
					}
					const result = await THIS.rest("b2b.linelist.saveProduct", {}, form);
					echangeur.hash.preview = '';
					if (result.ok) THIS.hashChaine("linelist", echangeur.hash);

				},

				async modeEditSaveExclude() {
					const listExclude = this.product.filter(u => !u.selected).map(u => u.reference);
					const form = {
						_id: this.linelist._id,
						selectedProducts: { exclude: listExclude },
					}
					const result = await THIS.rest("b2b.linelist.saveProduct", {}, form);
					echangeur.hash.preview = "";
					if (result.ok) THIS.hashChaine("linelist", echangeur.hash);
				},

				async clickAddProduct(product, event) {


					if (this.mayOrder) {
						if (this.orderManagerData.currentOrder) {
							const data = await THIS.rest("b2b.saisie.addProduct", { _id: this.orderManagerData.currentOrder._id, reference: product.reference })
							Store.get("updateTotaux")(data);
							if (data.ok) {
								product.returnAddProduct = ''
							} else {
								createPopover(event.target, data.message);
								product.returnAddProduct = data.message;
							}
							// if (this.returnAddProduct) {
							// 	this.returnAddProduct = data.ok ? '' : 
							//  
							// }
							//console.log(this.returnAddProduct)
						} else {
							const callback = function (a) { };
							Store.get("selectOrder")(null, callback);
						}
					}
				},

				async clickDeleteProduct(product) {
					if (this.mayOrder) {
						if (this.orderManagerData.currentOrder) {
							const data = await THIS.rest("b2b.saisie.deleteProduct", { _id: this.orderManagerData.currentOrder._id, reference: product.reference })
							Store.get("updateTotaux")(data);
						}
					}
				},

				producInOrder(product) {
					// console.log(this.orderManagerData.currentOrder);
					if (this.orderManagerData.currentOrder && this.orderManagerData.currentOrder.rows) {
						const row = this.orderManagerData.currentOrder.rows.find(row => row.reference == product.reference);
						return (row) ? { has: true, qt: row.totaux.qt, select: true } : { has: false };
					} else {
						return { has: false };
					}
				},

				productUpdatable(product) {
					let retour = { updatable: false }
					if (this.orderManagerData.currentOrder) {

						let goodmarket = (this.orderManagerData.currentOrder.market == product.market);

						let orderdep = this.orderManagerData.currentOrder.orderdepartment;
						let gooddeep = (this.departements[orderdep] && this.departements[orderdep].rows.indexOf(product.departmentK) > -1)

						retour.orderdep = gooddeep;
						retour.market = goodmarket;

						const goodtaille = (product.tailles.length === 1)
						const goodqt = (!product.qt && product.qt !== '')

						retour.updatable = (gooddeep && goodmarket && goodtaille && goodqt);

					}
					return retour.updatable;
				},

				resetFilters() {
					//{ name: "haut", title: "Heel height", filter: this.clickFilterHaut, dropdown: { name: 'haut', key: 0, list: [], checked: [], actif: false } },
					for (const item of this.activeDropdown) {
						const filter = getFilter(item.name);
						filter.setChecked([]);
						this.filtreActif[item.name] = 0;
					}
					if (this.searchKey !== "") {		//!!!! douteux
						this.searchKey = "";
						filterRef.setChecked([]);
					} else {
						this.blocs = prepareEtat.construit(jeuDeDonnees.getRows());
					}
				},

				clickFilter(event, item) {
					const filter = getFilter(item.name);
					if (filter) {
						item.dropdown.list = filter.valeursPossibles().map(u => ({ k: u, v: u }));
						item.dropdown.checked = filter.getChecked();
						item.dropdown.key++; //Restart			
					}
					//
					item.dropdown.close = function () { new Dropdown(event.target).hide() };
				},

				hideFilter(name) {

				},

				filtreFin(name, checkeds) {

					const filter = getFilter(name);

					if (filter) {
						filter.setChecked(checkeds);
						this.filtreActif[name] = checkeds.length;
					}
					this.blocs = prepareEtat.construit(jeuDeDonnees.getRows());
					const dropdown = this.activeDropdown.find(u => u.name == name);
					dropdown.dropdown.close();

					return
					//
				},

				handleScroll: function () {
					if (this.scTimer) return;
					this.scTimer = setTimeout(() => {
						this.scY = window.scrollY;
						clearTimeout(this.scTimer);
						this.scTimer = 0;
					}, 100);
				},

				toTop: function () {
					window.scrollTo({
						top: 0,
						behavior: "smooth"
					});
				},

				lanceRecherche(val) {

					//console.log("lanceRecherche", val)
					if (val) {
						const values = fuse.search(val);
						const references = values.map(u => u.item.reference);
						if (references.length === 0) {
							filterRef.setChecked([""]);
						} else {
							filterRef.setChecked(references);
						}
					} else {
						filterRef.setChecked([]);
					}
					this.blocs = prepareEtat.construit(jeuDeDonnees.getRows());
					//
				},

			},

			watch: {
				"searchKey"(val) {
					this.lanceRecherche(val);
				},
				"orderManagerData.currentOrder"(val) {
					if (this.onstock) {
						this.blocs = this.blocs.map(x => {
							x.data.hiddenStock = !(Object.keys(x.data.stock).includes(val.codestock) === true);
							return x
						})
						this.blocs = prepareEtat.construit(jeuDeDonnees.getRows());
					}
				},
			},

			mounted() {
				window.addEventListener('scroll', this.handleScroll);
			}

		});

		this.vm = app.mount(THIS.c$('._vueChargement')[0]);

	},

	reprise: async function (ecran) {

		this.vm.$data.orderManagerData.currentOrder = await Store.get("getCurrentOrder")();
		if (this.vm.$data.orderManagerData && this.vm.$data.orderManagerData.currentOrder) {
			for (let bloc of this.vm.$data.blocs) {
				let ligne = this.vm.$data.orderManagerData.currentOrder.rows.find(u => (bloc.data.reference == u.reference));
				if (bloc.data.saisie && bloc.data.saisie.qt > 0 && !ligne) bloc.data.saisie.qt = "";
			}

			if (this.vm.$data.onstock) {
				let stockcode = this.vm.$data.orderManagerData.currentOrder.codestock;
				console.log('stockcode', stockcode)
				this.vm.$data.blocs = this.vm.$data.blocs.map(x => {
					x.data.hiddenStock = (x.data?.stock[stockcode] === true);
					return x
				})
			}
		}


		this.toggle(true);
		ecran.restaure();
	}
});

export default {
	linelist: { js: jsLinelist, html: htmlLinelist },
	linelistproduct: { js: jsLinelist, html: htmlLinelist },
};




// <div class="btn-group">
//   <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
//     Clickable inside
//   </button>
//   <ul class="dropdown-menu">
//     <li><span class="dropdown-item"  >Menu item</a></span>
//     <li><span class="dropdown-item"  >Menu item</a></span>
//     <li><span class="dropdown-item" >Menu item</a></span>
//   </ul>
// </div>



